import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusCardActionArea], [campus-card-action-area], campus-card-action-area',
})
export class CardActionAreaDirective {
  @HostBinding('class')
  defaultClasses = ['flex', 'flex-auto', 'flex-column', 'justify-end'];
}
